module.exports = __webpack_public_path__ + "media/images/area/maps/okinawa-66856fc23d78ce85a0ae1aaa4da4014a.svg";